import { Box, Grid } from '@mui/material';
import { Project } from '../Projects/projects';
import { useEffect, useMemo, useState } from 'react';
import { loadExamples } from '../../utils/helpers';
import ExampleCard from './ExampleCard';
import { EXAMPLE_TAGS } from '../../utils/constants';

interface ExampleListProps {
  filterTag: string;
}

const ExampleList = ({ filterTag }: ExampleListProps) => {
  const [examples, setExamples] = useState<Project[]>([]);

  useEffect(() => {
    loadExamples().then(setExamples);
  }, []);

  const sortedExamples = useMemo(() => {
    if (filterTag === EXAMPLE_TAGS[0] || !filterTag) return examples;
    return examples.filter((example) => example.tags?.includes(filterTag));
  }, [examples, filterTag]);

  return (
    <Box>
      <Grid container spacing={3} sx={{ px: 2 }}>
        {sortedExamples?.map((example: Project) => (
          <Grid key={example.id} sx={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ExampleCard example={example} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ExampleList;
